module.exports = __webpack_public_path__ + "files/c5780bdf133b26501076b1997d864f69.svg";